import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import api from './api'
import * as echarts from 'echarts';



Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.use(api)
Vue.filter('number', function (number) {
  return number - 0;
});
Vue.prototype.$viewUrl = function (variable) {

  var url = window.location.href;
  var index = url.indexOf("?");
  if (index != -1) {
    var str = url.substr(index + 1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      var arr = strs[i].split("=");
      var value = '';
      if (strs.length - 1 == i) {
        var newstr = arr[1].split('#');
        value = newstr[0];
      } else {
        value == arr[1];
      }

      if (arr[0] == variable) {
        return value;
      }
    }
  }
  return false;
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
